import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={6}
    height={10}
    fill="none"
    viewBox="0 0 6 10"
    {...props}
  >
    <path
      fill="#999"
      d="m2 5 3.25 3.25a.79.79 0 0 1 .23.583.79.79 0 0 1-.23.584.79.79 0 0 1-.583.229.79.79 0 0 1-.584-.23L.25 5.584a.731.731 0 0 1-.177-.27A.922.922 0 0 1 .021 5c0-.111.017-.215.052-.312a.731.731 0 0 1 .177-.271L4.083.583a.79.79 0 0 1 .584-.229.79.79 0 0 1 .583.23.79.79 0 0 1 .23.583.79.79 0 0 1-.23.583z"
    />
  </svg>
);
export default SvgChevronLeft;
